<template>
  <div v-if="shouldShow">
    <div class="activity-dialog">
      <el-dialog
        :show-close="false"
        :lock-scroll="true"
        custom-class="dialog"
        top="25vh"
        :close-on-click-modal="true"
        :visible.sync="showDialog"
        :modal-append-to-body="false"
      >
        <div class="relative">
          <img :src="imageUrl" alt="" width="780" height="575" />
          <img
            class="absolute close-icon cursor-pointer"
            src="@cdn?55283627ab75"
            alt=""
            width="30"
            height="30"
            @click.stop="close"
          />
          <!--          <img-->
          <!--            src="@cdn?b1158bb1968d" class="absolute cursor-pointer" style="height: 80px;right: 32px;bottom: 37px;"-->
          <!--            @click="close" />-->
          <div
            class="absolute"
            style="
              bottom: 62px;
              left: 40px;
              height: 144px;
              padding: 8px;
              background-color: white;
              border-radius: 10px;
            "
          >
            <img class="cursor-pointer w100p h100p" src="@cdn?3d6078a5797c" alt="" />
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gls, sls } from '@/utils/storage'
import { preLoadImage } from '@/utils/tools'
import { trackEvent } from '@/common/event'

const ACTIVITY_KEY = '20221228ACTIVITY_KEY'

export default {
  name: 'ActivityDialog',
  data() {
    return {
      showDialog: false,
      loadedImage: false,
      imageUrl: require('@cdn?7e0eca0683cb')
    }
  },
  computed: {
    ...mapGetters('route', ['pageLoading']),
    shouldShow() {
      return !this.pageLoading && !this.$route.meta.notShowDialog
    }
  },
  created() {
    const hasShowed = gls(ACTIVITY_KEY)
    if (!hasShowed) {
      // this.open()
    }
  },
  methods: {
    open() {
      preLoadImage(this.imageUrl).then(() => {
        trackEvent('Home', 'View', 'AnnualReportWindow')
        this.showDialog = true
        sls(ACTIVITY_KEY, true)
      })
    },
    close() {
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-dialog {
  z-index: 1002;

  &::v-deep {
    .dialog {
      &.el-dialog {
        position: absolute;
        top: 50%;
        left: 50%;
        display: flex;
        max-width: calc(100% - 30px);

        /* height:600px; */
        max-height: calc(100% - 30px);
        margin: 0 !important;
        transform: translate(-50%, calc(-575px / 2));
        flex-direction: column;
      }

      .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
      }

      width: 780px;
      height: 0;
      background: #fff !important;
      border-radius: 12px;
    }

    .el-dialog__header {
      display: none;
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .close-icon {
    top: 20px;
    right: 31px;
  }
}
</style>
